import Amount from './Amount';
import Remark from './Remark';

export default {
  Amount,
  Remark,
};



// WEBPACK FOOTER //
// ./src/components/Reminders/ExceptionTypes/index.js